// Job Completion Event Emitter - Global event system for job completion
// Separated into its own file to avoid circular dependencies

export const jobCompletionEmitter = {
  listeners: [],
  on: (callback) => {
    jobCompletionEmitter.listeners.push(callback);
    return () => {
      const index = jobCompletionEmitter.listeners.indexOf(callback);
      if (index > -1) jobCompletionEmitter.listeners.splice(index, 1);
    };
  },
  emit: (jobId, videoData) => {
    console.log('🎉 Job completion event emitted:', jobId, videoData);
    jobCompletionEmitter.listeners.forEach(cb => {
      try {
        cb(jobId, videoData);
      } catch (error) {
        console.error('Error in job completion listener:', error);
      }
    });
  }
};
